/* eslint-disable no-console,no-cond-assign */

export interface WsEvent {
  data: string
}

export type OnOpenHandler = (this: WebSocket, ev: Event) => void
export type WsHandler = (ev: WsEvent, ws?: WebSocket) => void

interface SegmentData {
  action: 'sendSeg'
  cid: string
  data: string
}

export class WsSocket {
  private handlerList: WsHandler[] = []
  private toSend = ''
  private isSending = false
  private sendList: string[] = []
  private toReceive = ''
  private wssocket: WebSocket

  constructor(wsurl: string, onopen: OnOpenHandler, handler?: WsHandler) {
    console.log(`[createWS.js] createWssocket : ${wsurl}`)
    if (handler) {
      this.handlerList.push(handler)
    }

    // TODO: we don't need monitor at all?
    this.monitor()

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this

    const wssocket = (this.wssocket = new WebSocket(wsurl))
    wssocket.onerror = function (error): void {
      console.log(error)
    }
    wssocket.onopen = onopen

    const onmessage = function (this: WebSocket, event: MessageEvent): void {
      const obj = JSON.parse(event.data as string) as { action: string }
      switch (obj.action) {
        case 'sendNextSegment':
          that.sendNextSegment()
          break
        case 'sendSeg':
          that.receiveSeg(obj as SegmentData)
          break
        default:
          that.handlerList.forEach((h) => h(event, this))
      }
    }
    wssocket.onmessage = onmessage

    const reconnect = function (): void {
      setTimeout(() => {
        console.log('[createWS.js] try to reconnect')
        const wssocket = (that.wssocket = new WebSocket(wsurl))
        wssocket.onclose = reconnect
        wssocket.onmessage = onmessage
        wssocket.onopen = onopen
      }, 1000)
    }
    wssocket.onclose = reconnect
  }

  status(): WebSocket['CLOSED' | 'CLOSING' | 'CONNECTING' | 'OPEN'] {
    return this.wssocket.readyState
  }

  sendNextSegment(): void {
    const str = this.toSend
    if (str.length > 1024) {
      this.toSend = str.substr(1024)
      const obj = {
        isSegment: true,
        data: str.substr(0, 1024),
      }
      this.wssocket.send(JSON.stringify(obj))
    } else {
      this.toSend = ''
      const obj = {
        isSegment: false,
        data: str,
      }
      this.wssocket.send(JSON.stringify(obj))
      this.isSending = false
      let data
      if ((data = this.sendList.pop())) {
        this.send(data)
      }
    }
  }

  receiveSeg(obj: SegmentData): void {
    if (obj.cid === 'start') {
      this.toReceive = ''
    }
    this.toReceive += obj.data
    if (obj.cid === 'done') {
      console.log(`[receiveSeg] Received AllData:${this.toReceive}`)
      const event: WsEvent = {
        data: this.toReceive,
      }
      this.toReceive = ''
      this.handlerList.forEach((h) => h(event, this.wssocket))
    }
  }

  monitor(): void {
    if (!this.isSending) {
      let data
      if ((data = this.sendList.pop())) {
        this.send(data)
      }
    }
    setTimeout(() => this.monitor(), 1000)
  }

  send(data: string): void {
    if (this.isSending) {
      this.sendList.push(data)
      return
    }
    if (data.length > 1024) {
      this.isSending = true
      this.toSend = data.substr(1024)
      const obj = {
        isSegment: true,
        data: data.substr(0, 1024),
      }
      this.wssocket.send(JSON.stringify(obj))
    } else {
      this.wssocket.send(data)
    }
  }

  addHandler(handler: WsHandler): void {
    this.handlerList.push(handler)
  }
}
